export const statusConstants = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
}